import { useState } from 'react';
import { faqList } from '@/mocks/faq';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggleFaq = (id: string) => {
    setOpenId(prev => prev === id ? null : id);
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map(faq => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            常见问题解答
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            关于磁力链接和磁力网站的常见疑问，这里都有详细解答。
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqList.map(faq => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                onClick={() => toggleFaq(faq.id)}
              >
                <span className="font-medium text-foreground-900 text-sm pr-4">{faq.question}</span>
                <div className={`w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openId === faq.id ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}